module.exports = __webpack_public_path__ + "img/genesisgaming.75838625.svg";